<qm-train-alarm-actions
  *ngIf="!!alarm"
  [tripNumber]="alarm.metadata.payload.tripNumber"
  (trainNumberClicked)="toggleTooltip($event, ttip)"
  #ttip="qmTooltip"
  [openPanelOnClick]="false"
  [qmTooltip]="tooltipContent"
  [darkBtn]="true">
</qm-train-alarm-actions>

<ng-template #tooltipContent let-message="message">
  <div class="tooltip">
    <p *ngFor="let paragraph of message" class="paragraph">
      {{ paragraph }}
    </p>
  </div>
</ng-template>